import type {PrimaryConfigOptions} from '../index';
import type {IconButtonType} from '../styles.types';

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;

  styleManager.addType('pmw-icon-button', {
    create(data: any) {
      const {change} = data;
      const props = data.props as IconButtonType;
      props.component = props.component ?? editor.getSelected();

      const el = document.createElement('div');
      const btnClass = props.class ?? '';
      el.className = 'pmw-email-editor-icon-button radius-4 ' + btnClass;

      if (typeof props.callback !== 'function') {
        props.callback = function (): void {
          // Default empty callback
        };
      }

      props.iconClass = props.iconClass || 'icon-user';
      props.description = props.description || '';

      if (props.property === 'lock') {
        if (props.component) {
          if (props.component.get('draggable')) {
            props.description = window.i18next.t('pmwjs_lock');
            props.iconClass = 'icon-lock';
          } else {
            props.description = window.i18next.t('pmwjs_unlock');
            props.iconClass = 'icon-unlock';
          }
        }
      }

      el.innerHTML = '<i class="pmw-icon-button-icon ' + props.iconClass + '"></i>' + '<span class="pmw-icon-button-text">' + props.description + '</span>';

      el.addEventListener(
        'click',
        function (el: HTMLElement, e: Event): void {
          change({el, e});
        }.bind(this, el)
      ); // change will trigger the emit

      return el;
    },

    emit(data: any, emitData: {el: HTMLElement; event?: Event; complete?: boolean}): void {
      const props = data.props as IconButtonType;
      props.callback(emitData.el);
    },

    update(): void {
      // Empty update method
    },
  });
};
